import { useDispatch, useSelector } from 'react-redux';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { getRelativeUrl, findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';
import CartIcon from 'yoda-core-components/lib/assets/svg/QuickAddToCart.svg';
import React, { useCallback, useEffect } from 'react';
import get from 'lodash/get';
import { showLoader } from '../../actions/LoadingAction';
import { selectProduct } from '../../actions/MiniPDPAction';
import { showLazy } from '../../lazy/actions/LazyAction';
import { setOnBasketBeaconStatus } from '../../actions/CriteoAction';

/**
 *  Gets the theme to use
 *  @return {[Object]} [theming classes]
 * */
const getThemeConfig = (themeConfig) => {
    const wrapper = themeConfig.wrapperClass || 'wrapper';
    const wrapperClass = `${wrapper} sm12 md12 lg12 xl12`;

    const customClassName = themeConfig.customClassNameClass || '';
    const customClassNameClass = `addToCartBlock ${customClassName}`;

    const buttonCustom = themeConfig.buttonCustomClass || '';
    const buttonClass = `buttonStyle ${buttonCustom}`;
    return {
        wrapperClass,
        customClassNameClass,
        buttonClass,
    };
};

export default function QuickAddToCart({
    enableMiniPDP,
    location,
    ppId,
    themeConfig,
    buttonType,
    automationId,
    url,
    skuId,
    iconStyle,
    buttonText,
    isAddToCartClick,
    onAddToCartClick,
    miniPDPTriggerEvent,
    gallerySmoothScroll,
    OnBasketChangeBeacon,
    productskuId,
}) {
    const state = useSelector((store) => store);
    const { enableMiniPDPFeature = false } = state?.context?.featureFlags;
    const { isDesktop = true } = state?.context?.deviceType;

    const criteoData = useSelector((state) => get(state, 'criteo', {}));

    const { onBasketBeaconCalledPPIDs = [] } = criteoData;

    const dispatch = useDispatch();
    const windowWidth = !__SERVER__ && window.innerWidth;

    const theme = getThemeConfig(themeConfig);

    const addToCartButton = useCallback(
        (e) => {
            e && e.preventDefault();
            const eventData = e?.detail;
            if (eventData && eventData.ppId) {
                ({ ppId, url, skuId } = eventData);
            }
            if (ppId) {
                url = getRelativeUrl(url);
                const PDPUrl = url || `/p/product/${ppId}?pTmplType=regular`;
                const topOfElement = !__SERVER__ ? window.pageYOffset : 1000;
                const selections = {
                    skuId,
                    ppId,
                    url: PDPUrl,
                    galleryOffset: topOfElement,
                    galleryscrollToskuID: productskuId,
                };
                dispatch(selectProduct(selections));
                dispatch(showLazy('miniPDP'));
                dispatch(showLoader());
                onAddToCartClick(selections);
                if (OnBasketChangeBeacon && !onBasketBeaconCalledPPIDs?.includes(productskuId)) {
                    console.log('===> onAddToCartClick', 'click have been perfomed');
                    navigator.sendBeacon(`https:${OnBasketChangeBeacon}`);
                    dispatch(setOnBasketBeaconStatus(productskuId));
                }
            }
            if (
                gallerySmoothScroll &&
                !__SERVER__ &&
                findMobileOS() === 'iOS' &&
                document.documentElement.classList.contains('scroll-smooth')
            ) {
                document.documentElement.classList.remove('scroll-smooth');
            }
        },
        [ppId]
    );

    /* istanbul ignore next */
    const getIconSize = (windowWidth) => {
        if (isDesktop) {
            return windowWidth && windowWidth >= 1440 ? '26px' : '26px';
        }
        return '24px';
    };

    /* istanbul ignore next */
    const getIconViewBox = (windowWidth) => {
        if (isDesktop) {
            return windowWidth && windowWidth >= 1440 ? '0 0 26 26' : '0 0 26 26';
        }
        return '0 0 24 24';
    };

    useEffect(() => {
        if (isAddToCartClick) {
            addToCartButton();
        }

        if (miniPDPTriggerEvent) {
            document.addEventListener(miniPDPTriggerEvent, addToCartButton);
        }
    }, []);

    if (enableMiniPDP && enableMiniPDPFeature) {
        const uniqueId = `${location}-${ppId}`;
        const iconSize = getIconSize(windowWidth);
        return (
            <div
                className={theme.wrapperClass}
                id={uniqueId}
                data-component-name="quickAddToCartContainer"
            >
                <Button
                    size="Md"
                    buttonType={buttonType}
                    automationId={automationId}
                    className={`${theme.buttonClass} btnText`}
                    onClick={addToCartButton}
                >
                    {iconStyle ? (
                        <Icon
                            iconType="svg"
                            classNames="icon"
                            viewBox={getIconViewBox(windowWidth)}
                            width={iconSize}
                            height={iconSize}
                            automationId="filter-icon"
                        >
                            <CartIcon />
                        </Icon>
                    ) : (
                        <>{buttonText}</>
                    )}
                </Button>
            </div>
        );
    }

    return null;
}

QuickAddToCart.defaultProps = {
    automationId: '',
    buttonType: 'Secondary',
    buttonText: 'Add To Cart',
    enableMiniPDP: false,
    themeConfig: {},
    skuId: '',
    ppId: '',
    url: '',
    location: '',
    actions: {},
    miniPDPTriggerEvent: null,
    onAddToCartClick: () => {},
    isAddToCartClick: false,
    iconStyle: false,
    gallerySmoothScroll: false,
};
